export const RESPONSE_PER_PAGE = 50;
export const MIN_TAG_LENGTH = 2;

export type ChannelInfoType = {
  id: string;
  name: string;
  icon: string;
};

export type LangType = {
  id: string;
  name: string;
};

export const DEFAULT_LANGUAGE_OPTIONS: LangType[] = [
  { name: 'contacts.import_contact.form_choices.language.bs', id: 'bs' },
  { name: 'contacts.import_contact.form_choices.language.bg', id: 'bg' },
  { name: 'contacts.import_contact.form_choices.language.ca', id: 'ca' },
  {
    name: 'contacts.import_contact.form_choices.language.zh-cn',
    id: 'zh-cn',
  },
  {
    name: 'contacts.import_contact.form_choices.language.zh-tw',
    id: 'zh-tw',
  },
  { name: 'contacts.import_contact.form_choices.language.hr', id: 'hr' },
  { name: 'contacts.import_contact.form_choices.language.cs', id: 'cs' },
  { name: 'contacts.import_contact.form_choices.language.da', id: 'da' },
  { name: 'contacts.import_contact.form_choices.language.nl', id: 'nl' },
  {
    name: 'contacts.import_contact.form_choices.language.en',
    id: 'en',
  },
  { name: 'contacts.import_contact.form_choices.language.et', id: 'et' },
  { name: 'contacts.import_contact.form_choices.language.fil', id: 'fil' },
  { name: 'contacts.import_contact.form_choices.language.fi', id: 'fi' },
  { name: 'contacts.import_contact.form_choices.language.fr', id: 'fr' },
  { name: 'contacts.import_contact.form_choices.language.de', id: 'de' },
  { name: 'contacts.import_contact.form_choices.language.el', id: 'el' },
  { name: 'contacts.import_contact.form_choices.language.hu', id: 'hu' },
  { name: 'contacts.import_contact.form_choices.language.is', id: 'is' },
  {
    name: 'contacts.import_contact.form_choices.language.id',
    id: 'id',
  },
  { name: 'contacts.import_contact.form_choices.language.it', id: 'it' },
  { name: 'contacts.import_contact.form_choices.language.ja', id: 'ja' },
  { name: 'contacts.import_contact.form_choices.language.ko', id: 'ko' },
  { name: 'contacts.import_contact.form_choices.language.lv', id: 'lv' },
  {
    name: 'contacts.import_contact.form_choices.language.lt',
    id: 'lt',
  },
  { name: 'contacts.import_contact.form_choices.language.ms', id: 'ms' },
  { name: 'contacts.import_contact.form_choices.language.no', id: 'no' },
  { name: 'contacts.import_contact.form_choices.language.pl', id: 'pl' },
  {
    name: 'contacts.import_contact.form_choices.language.pt-br',
    id: 'pt-br',
  },
  {
    name: 'contacts.import_contact.form_choices.language.pt-pt',
    id: 'pt-pt',
  },
  { name: 'contacts.import_contact.form_choices.language.ro', id: 'ro' },
  { name: 'contacts.import_contact.form_choices.language.ru', id: 'ru' },
  { name: 'contacts.import_contact.form_choices.language.sr', id: 'sr' },
  { name: 'contacts.import_contact.form_choices.language.sk', id: 'sk' },
  { name: 'contacts.import_contact.form_choices.language.sl', id: 'sl' },
  { name: 'contacts.import_contact.form_choices.language.es', id: 'es' },
  {
    name: 'contacts.import_contact.form_choices.language.es-la',
    id: 'es-la',
  },
  { name: 'contacts.import_contact.form_choices.language.sv', id: 'sv' },
  { name: 'contacts.import_contact.form_choices.language.th', id: 'th' },
  { name: 'contacts.import_contact.form_choices.language.tr', id: 'tr' },
  { name: 'contacts.import_contact.form_choices.language.uk', id: 'uk' },
  {
    name: 'contacts.import_contact.form_choices.language.vi',
    id: 'vi',
  },
  { name: 'contacts.import_contact.form_choices.language.cy', id: 'cy' },
];

export type NoteCategoryType = {
  category: string;
  action: string;
  text: string | null;
  isHidden: boolean;
};

export const NoteTypeInfo: NoteCategoryType[] = [
  {
    action: 'Non Actionable',
    category: 'default',
    text: 'responses.card.note_type.marked_as_non_actionable',
    isHidden: false,
  },
  {
    action: 'Actionable',
    category: 'default',
    text: 'responses.card.note_type.marked_as_actionable',
    isHidden: false,
  },
  {
    action: 'Favourite',
    category: 'default',
    text: 'responses.card.note_type.marked_as_favorite',
    isHidden: false,
  },
  {
    action: 'Unfavourite',
    category: 'default',
    text: 'responses.card.note_type.removed_favorite',
    isHidden: false,
  },
  {
    action: 'Invalid',
    category: 'primary',
    text: 'responses.card.note_type.marked_as_invalid',
    isHidden: false,
  },
  {
    action: 'Valid',
    category: 'default',
    text: 'responses.card.note_type.marked_as_valid',
    isHidden: false,
  },
  {
    action: 'Workflow',
    category: 'info',
    text: null,
    isHidden: false,
  },
  {
    action: 'Tag',
    category: 'default',
    text: 'responses.card.note_type.added_a_tag',
    isHidden: false,
  },
];

export const TRANSACTION_PROPERTIES = [
  {
    id: 1,
    name: 'responses.transaction_properties.ticket_id',
    value: '2132131',
  },
  {
    id: 2,
    name: 'responses.transaction_properties.purchase_id',
    value: 'HUA29238NUN2HUA29238NUN2HUA29238NUN2',
  },
  {
    id: 3,
    name: 'responses.transaction_properties.customer_id',
    value: '2131',
  },
  {
    id: 4,
    name: 'responses.transaction_properties.resolved_date',
    value: '01 Mar 2022 08:23pm',
  },
  {
    id: 5,
    name: 'responses.transaction_properties.purchase_date',
    value: '16 Feb 2022 08:00pm',
  },
  {
    id: 6,
    name: 'responses.transaction_properties.SKU',
    value: '2132131',
  },
  {
    id: 7,
    name: 'responses.transaction_properties.Ticket ID',
    value: '2132131',
  },
  {
    id: 8,
    name: 'responses.transaction_properties.payment_mode',
    value: 'UPI',
  },
  {
    id: 9,
    name: 'responses.transaction_properties.subscription_type',
    value: 'Premium',
  },
  {
    id: 10,
    name: 'responses.transaction_properties.payment_status',
    value: 'Paid',
  },
];

export const SURVEY_THEMES = [
  { id: 'ALL', value: 'survey_theme.all_cp' },
  { id: 'NPS', value: 'survey_theme.nps_cp' },
  { id: 'CSAT', value: 'survey_theme.csat_cp' },
  { id: 'CES', value: 'survey_theme.ces_cp' },
];

export const DEFAULT_ORDER = 'ascending';
export const DEFAULT_QUESTION_THEME = 'NPS';
